var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackdropCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1186,
    height: 1444,
    viewBox: "0 0 1186 1444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M783.5 0C350.785 0 0 323.25 0 722C0 1120.75 350.785 1444 783.5 1444C1216.22 1444 1567 1120.75 1567 722C1567 323.25 1216.22 0 783.5 0Z",
    fill: "#DBD5F9",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M935.483 521.579C844.309 521.579 770.398 589.688 770.398 673.706C770.398 757.723 844.309 825.833 935.483 825.833C1026.66 825.833 1100.57 757.723 1100.57 673.706C1100.57 589.688 1026.66 521.579 935.483 521.579Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint0_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M935.483 536.067C852.992 536.067 786.12 597.69 786.12 673.706C786.12 749.722 852.992 811.344 935.483 811.344C1017.97 811.344 1084.85 749.722 1084.85 673.706C1084.85 597.69 1017.97 536.067 935.483 536.067Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint1_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M935.483 550.555C861.675 550.555 801.842 605.692 801.842 673.706C801.842 741.72 861.675 796.856 935.483 796.856C1009.29 796.856 1069.12 741.72 1069.12 673.706C1069.12 605.692 1009.29 550.555 935.483 550.555Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint2_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M935.484 565.044C870.36 565.044 817.566 613.693 817.566 673.706C817.566 733.718 870.36 782.368 935.484 782.368C1000.61 782.368 1053.4 733.718 1053.4 673.706C1053.4 613.693 1000.61 565.044 935.484 565.044Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint3_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M935.484 579.532C879.043 579.532 833.288 621.695 833.288 673.706C833.288 725.717 879.043 767.88 935.484 767.88C991.925 767.88 1037.68 725.717 1037.68 673.706C1037.68 621.695 991.925 579.532 935.484 579.532Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint4_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M935.484 594.02C887.726 594.02 849.011 629.697 849.011 673.706C849.011 717.715 887.726 753.391 935.484 753.391C983.242 753.391 1021.96 717.715 1021.96 673.706C1021.96 629.697 983.242 594.02 935.484 594.02Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint5_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M935.484 608.508C896.409 608.508 864.733 637.698 864.733 673.706C864.733 709.713 896.409 738.903 935.484 738.903C974.558 738.903 1006.23 709.713 1006.23 673.706C1006.23 637.698 974.558 608.508 935.484 608.508Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint6_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M935.483 622.997C905.092 622.997 880.455 645.7 880.455 673.706C880.455 701.712 905.092 724.415 935.483 724.415C965.875 724.415 990.512 701.712 990.512 673.706C990.512 645.7 965.875 622.997 935.483 622.997Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint7_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M935.483 637.485C913.775 637.485 896.177 653.701 896.177 673.706C896.177 693.71 913.775 709.926 935.483 709.926C957.191 709.926 974.789 693.71 974.789 673.706C974.789 653.701 957.191 637.485 935.483 637.485Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint8_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M935.483 651.973C922.458 651.973 911.899 661.703 911.899 673.706C911.899 685.708 922.458 695.438 935.483 695.438C948.508 695.438 959.066 685.708 959.066 673.706C959.066 661.703 948.508 651.973 935.483 651.973Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint9_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M935.483 666.461C931.141 666.461 927.621 669.705 927.621 673.706C927.621 677.706 931.141 680.95 935.483 680.95C939.824 680.95 943.344 677.706 943.344 673.706C943.344 669.705 939.824 666.461 935.483 666.461Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint10_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M783.683 237.846C494.444 237.846 259.97 453.916 259.97 720.452C259.97 986.987 494.444 1203.06 783.683 1203.06C1072.92 1203.06 1307.4 986.987 1307.4 720.452C1307.4 453.916 1072.92 237.846 783.683 237.846Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint11_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M813.829 265.674C541.262 265.674 320.303 469.29 320.303 720.462C320.303 971.634 541.262 1175.25 813.829 1175.25C1086.4 1175.25 1307.36 971.634 1307.36 720.462C1307.36 469.29 1086.4 265.674 813.829 265.674Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint12_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M845.85 291.677C590.968 291.677 384.345 482.081 384.345 716.956C384.345 951.832 590.968 1142.24 845.85 1142.24C1100.73 1142.24 1307.36 951.832 1307.36 716.956C1307.36 482.081 1100.73 291.677 845.85 291.677Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint13_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M583.08 435.907C417.382 588.598 417.382 836.16 583.08 988.851C748.778 1141.54 1017.43 1141.54 1183.12 988.851C1348.82 836.16 1348.82 588.598 1183.12 435.907C1017.43 283.215 748.777 283.215 583.08 435.907Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint14_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M920.532 356.006C706.895 356.006 533.708 515.599 533.708 712.466C533.708 909.334 706.895 1068.93 920.532 1068.93C1134.17 1068.93 1307.36 909.334 1307.36 712.466C1307.36 515.599 1134.17 356.006 920.532 356.006Z",
    fill: "#DBD5F9",
    fillOpacity: 0.1,
    stroke: "url(#paint15_linear_25508_212700)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25508_212700",
    x1: 1016.79,
    y1: 621.101,
    x2: 693.572,
    y2: 856.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25508_212700",
    x1: 1009.05,
    y1: 626.111,
    x2: 716.611,
    y2: 839.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25508_212700",
    x1: 1001.31,
    y1: 631.121,
    x2: 739.65,
    y2: 821.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25508_212700",
    x1: 993.563,
    y1: 636.131,
    x2: 762.691,
    y2: 804.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25508_212700",
    x1: 985.819,
    y1: 641.141,
    x2: 785.73,
    y2: 787.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25508_212700",
    x1: 978.075,
    y1: 646.151,
    x2: 808.769,
    y2: 769.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25508_212700",
    x1: 970.331,
    y1: 651.161,
    x2: 831.808,
    y2: 752.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25508_212700",
    x1: 962.587,
    y1: 656.171,
    x2: 854.846,
    y2: 734.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25508_212700",
    x1: 954.843,
    y1: 661.181,
    x2: 877.885,
    y2: 717.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_25508_212700",
    x1: 947.099,
    y1: 666.191,
    x2: 900.924,
    y2: 699.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_25508_212700",
    x1: 939.354,
    y1: 671.201,
    x2: 923.963,
    y2: 682.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_25508_212700",
    x1: 1041.63,
    y1: 553.57,
    x2: 16.2507,
    y2: 1301.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_25508_212700",
    x1: 1056.91,
    y1: 563.2,
    x2: 90.6317,
    y2: 1267.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_25508_212700",
    x1: 1073.16,
    y1: 569.897,
    x2: 169.576,
    y2: 1228.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_25508_212700",
    x1: 927.128,
    y1: 480.605,
    x2: 753.573,
    y2: 1441.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_25508_212700",
    x1: 1111.06,
    y1: 589.205,
    x2: 353.693,
    y2: 1141.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdropCircles);
export default __webpack_public_path__ + "static/media/BackdropCircles.b712c6344e714da8c0b8146e94ee458a.svg";
export { ForwardRef as ReactComponent };